import React from "react"

import Div from '../layouts/Div'
import Backend from '../../utils/Backend'

export default class FileUploader extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      file: props.file,
      params: props.params,
      endpoint: props.endpoint,
      placeholder: props.placeholder
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _onFileChange(e) {
    let {
      endpoint,
      params
    } = this.state

    var files = e.target.files;
    var filesArr = Array.prototype.slice.call(files);
    let file = filesArr[0]
    if(file == null){
      return
    }
    this.setState({ loading: true })
    this.props.onUploading()
    if(!this.props.canUpload){
      return
    }
    Backend.uploadFile(file, endpoint, params)
    .then(file => {
      this.setState({
        file,
        loading: false
      })
      this.props.onUploaded(file)
    })
    .catch(error => {
      this.setState({ loading: false })
      alert(error.message)
    })

  }

  render() {

    let {
      file,
      loading,
      placeholder
    } = this.state

    let filename = file?.name || file?.original
    let label = filename || placeholder
    return (
      <Div disabled={loading}>
        <div className="input-group">
          <div className="custom-file">
            <input
              type="file"
              className="custom-file-input"
              accept={this.props.accept}
              onChange={e => this._onFileChange(e)}
            />
            <label 
              className={`custom-file-label ${filename?'value':'placeholder'}`}
            >{label}</label>
            <span class="icon-upload material-icons">
              cloud_upload
            </span>
          </div>
        </div>
      </Div>
    )
  }
}


FileUploader.defaultProps = {
  canUpload: true,
  className: "",
  placeholder: "Choose file"
}
